/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {StateService} from '@uirouter/core';
import {ToastrService} from 'ngx-toastr';

import template from './creative-context-actions.component.html';
import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {CreativeCopyModalService} from './creative-copy-modal.service';
import {CreativeModel} from './creative-api.service';
import {handleCopyModalResult} from '../common/util/handle-copy-modal-result';

@Component({
  standalone: false,
  selector: 'adn-creative-context-actions',
  template
})
export class CreativeContextActionsComponent {
  @Input() state: SignalAdminResourcePageState<CreativeModel>;
  @Input() blockDelete: any;

  constructor(
    private readonly $state: StateService,
    private readonly toastr: ToastrService,
    private readonly copyModalService: CreativeCopyModalService
  ) {
  }

  copy(): void {
    const model = this.state?.model();
    if (this.state?.readOnly() || this.blockDelete || !model) {
      return;
    }
    this.copyModalService.open({
      model,
      specifiedAdvertiser: model.advertiser,
      onComplete: (result) => {
        handleCopyModalResult(() => {
          if (result.destination && result.creativeId) {
            this.$state.go('app.adv.creatives.creative', {id: result.creativeId});
          } else if (!result.destination) {
            this.toastr.success('A copy of this creative was successfully created.', 'Creative Copied');
          }
        });
      }
    });
  }
}
